import fb, { storage } from "./fb";

const db = fb.firestore();

// all database functionality here
class DB {
  constructor(collection) {
    this.collection = collection;
  }

  makeRef = () => db.collection(this.collection).createRef().id;

  reformat(doc) {
    try {
      return { id: doc.id, ...doc.data() };
    } catch (e) {
      // When creating a reference it will go here
      return { id: doc.id };
    }
  }

  findAll = async () => {
    const data = await db.collection(this.collection).get();
    return data.docs.map(this.reformat);
  };

  findByField = async (field, value) => {
    const data = await db
      .collection(this.collection)
      .where(field, "==", value)
      .get();
    return data.docs.map(this.reformat);
  };

  // findSubAll = async (id, sub) => {
  //     const data = await db.collection(this.collection).doc(id).collection(sub).get()
  //     return data.docs.map(this.reformat)
  // }

  // listen to entire collection,
  // on any change, loop over snapshot (all the data) and reformat
  // use set fn to change the state
  // return the unsubscribe which is returned from onSnapshot
  listenAll = (set) =>
    db
      .collection(this.collection)
      .onSnapshot((snap) =>
        !snap.empty ? set(snap.docs.map(this.reformat)) : set(null)
      );

  // listenSubAll = (set, id, sub) =>
  //     db.collection(this.collection).doc(id).collection(sub).onSnapshot(snap => set(snap.docs.map(this.reformat)))

  // listenSubOne = (set, id, sub, subId) =>
  //     db.collection(this.collection).doc(id).collection(sub).doc(subId).onSnapshot(snap => set(this.reformat(snap)))

  findOne = async (id) => {
    const doc = await db.collection(this.collection).doc(id).get();
    return doc.exists ? this.reformat(doc) : undefined;
  };

  findSubOne = async (id, subId) => {
    const doc = await db
      .collection(this.containing)
      .doc(id)
      .collection(this.collection)
      .doc(subId)
      .get();
    return doc.exists ? this.reformat(doc) : undefined;
  };

  listenOne = (set, id) =>
    db
      .collection(this.collection)
      .doc(id)
      .onSnapshot((snap) => set(this.reformat(snap)));

  listenByField = (set, field, value) =>
    db
      .collection(this.collection)
      .where(field, "==", value)
      .onSnapshot((snap) => set(snap.docs.map(this.reformat)));

  //creates a document in a subcollection
  // createSubDoc=( docId, sub, {id,...rest}) =>
  // db.collection(this.collection).doc(docId).collection(sub).add(rest)

  // item has no id
  create = ({ id, ...rest }) => db.collection(this.collection).add(rest);

  // item has id
  update = ({ id, ...rest }) =>
    db.collection(this.collection).doc(id).set(rest);

  remove = (id) => db.collection(this.collection).doc(id).delete();

  //formats Date
  formatDate(date) {
    const month = date.toLocaleString("default", { month: "long" });
    return date.getDate() + " " + month + " " + date.getFullYear();
  }

  // Search
  search = async (field, search) => {
    const data = await db
      .collection(this.collection)
      .orderBy(field)
      .where(field, ">=", search)
      .where(field, "<=", search + "\uf8ff")
      .get();
    return data.docs.map(this.reformat);
  };

  createRef = () => {
    return this.reformat(db.collection(this.collection).doc());
  };

  removeOneImage = async (object) => {
    let ref

    try {
      ref = storage.refFromURL(object.img);
    }
    catch {
      // If the user passed a url instead of an object
      ref = storage.refFromURL(object);
    }
    await ref.delete()
  };
}

//Mr Doug's Classes
class Users extends DB {
  constructor() {
    super("users");
  }

  listenToCount = (set) =>
    db.collection(this.collection).onSnapshot((snap) => set(snap.docs.length));
}

class EventCategories extends DB {
  constructor() {
    super("eventCategories");
  }
}

class Team extends DB {
  constructor() {
    super("team");
  }
}

class Events extends DB {
  constructor() {
    super("events");
  }

  // Deleting all Event's images
  removeEventImages = async (event) => {
    if (event) {
      await event.pictures.forEach(
        async (picture) => {
          await storage.refFromURL(picture).delete();
        }
      )
    }
  }
}

class Faq extends DB {
  constructor() {
    super("faq");
  }
}

class OurPartners extends DB {
  constructor() {
    super("ourPartners");
  }
}
class Contacts extends DB {
  constructor() {
    super("contacts");
  }
}

class Placeholders extends DB {
  constructor() {
    super("placeholders")
  }
}

export default {
  Users: new Users(),
  EventCategories: new EventCategories(),
  Events: new Events(),
  Team: new Team(),
  Faq: new Faq(),
  OurPartners: new OurPartners(),
  Contacts: new Contacts(),
  Placeholders: new Placeholders(),
};
